<template>
  <div class="kpis-page">
    <div v-if="emptydate">
      <DataPending />
    </div>
    <div v-if="!emptydate">
      <div class="reportchk">
        <el-form :inline="true">
          <el-form-item :label="$t('kpi.s110')">
            <el-radio-group v-model="reportchk2" size="mini" @change="setQueryTimeW">
              <el-tooltip 
                v-for="(item, index) in weeks.slice(0,windex)"
                :key="item.value + index"
                class="item" 
                effect="dark" 
                :content="item.tips"
                placement="top">
                <el-radio-button :label="item.value">{{item.label}}</el-radio-button>
              </el-tooltip>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('kpi.s111')" v-if="showmonths">
            <el-radio-group v-model="reportchk1" size="mini" @change="setQueryTimeM">
              <el-radio-button 
                v-for="(item, index) in months.slice(0,mindex)" 
                :key="item.value + index" 
                :label="item.label">
                {{item.label}}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <el-button class="downloadpdfbtn" type="danger" @click="downloaddata()" size="small">{{ $t('report.s54') }}</el-button>
        <span style="float:right; font-size:14px; margin-top:12px;">{{ $t('kpi.s38') }}：{{latestupdatetime}}</span>
      </div>

      <div class="page-header">
        <h2>{{ $t('kpi.s2') }}</h2>
      </div>

      <div class="kpis-page-top">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="12">
            <div class="kpis-page-col-panel">
              <h3>{{ reporttype == 1 ? $t('kpi.s301') : $t('kpi.s3') }}</h3>
              <h2 v-html="totalsku.currenthtml"></h2>
              <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ totalsku.last }}</h4>
              <span class="kpis-page-col-panel-bgicon kpcpb2"><i class="el-icon-present"></i></span>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12">
            <div class="kpis-page-col-panel">
              <h3>{{ reporttype == 1 ? $t('kpi.s501') : $t('kpi.s5') }}</h3>
              <h2 v-html="totalseller.currenthtml"></h2>
              <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ totalseller.last }}</h4>
              <span class="kpis-page-col-panel-bgicon kpcpb3"><i class="el-icon-shopping-cart-1"></i></span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="kpis-page-second">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="12">
            <div class="kpis-page-col-box">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="kpis-page-col-box-row1">
                    <h3>{{ reporttype == 1 ? $t('kpi.s601') : $t('kpi.s6') }}</h3>
                    <h2 v-html="lowpricesku.currenthtml"></h2>
                    <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ lowpricesku.last }}</h4>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="kpis-page-col-box-row2">
                    <el-row :gutter="20">
                      <el-col :xs="24" :sm="24">
                        <div class="kpis-page-col-box-row2-c kpcbrc1">
                          <h4>{{ $t('kpi.s7') }}</h4>
                          <h5 v-html="lowpricesku.percentagehtml"></h5>
                          <MiniLineChart :chartdata="lowpricesku.trend" minilineid="minilineid2" />
                        </div>
                      </el-col>
                    </el-row>  
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12">
            <div class="kpis-page-col-box">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="kpis-page-col-box-row1">
                    <h3>{{ reporttype == 1 ? $t('kpi.s801') : $t('kpi.s8') }}</h3>
                    <h2 v-html="lowpriceseller.currenthtml"></h2>
                    <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ lowpriceseller.last }}</h4>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="kpis-page-col-box-row2">
                    <el-row :gutter="20">
                      <el-col :xs="24" :sm="24">
                        <div class="kpis-page-col-box-row2-c kpcbrc2">
                          <h4>{{ $t('kpi.s9') }}</h4>
                          <h5 v-html="lowpriceseller.percentagehtml"></h5>
                          <MiniLineChart :chartdata="lowpriceseller.trend" minilineid="minilineid4" />
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" v-if="showinfringements">
            <div class="kpis-page-col-box">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="kpis-page-col-box-row1">
                    <h3>{{ reporttype == 1 ? $t('kpi.s1001') : $t('kpi.s10') }}</h3>
                    <h2 v-html="infringementsku.currenthtml"></h2>
                    <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ infringementsku.last }}</h4>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="kpis-page-col-box-row2">
                    <el-row :gutter="20">
                      <el-col :xs="24" :sm="24">
                        <div class="kpis-page-col-box-row2-c kpcbrc3">
                          <h4>{{ $t('kpi.s11') }}</h4>
                          <h5 v-html="infringementsku.percentagehtml"></h5>
                          <MiniLineChart :chartdata="infringementsku.trend" minilineid="minilineid6" />
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" v-if="showinfringements">
            <div class="kpis-page-col-box">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="kpis-page-col-box-row1">
                    <h3>{{ reporttype == 1 ? $t('kpi.s1201') : $t('kpi.s12') }}</h3>
                    <h2 v-html="infringementseller.currenthtml"></h2>
                    <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ infringementseller.last }}</h4>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="kpis-page-col-box-row2">
                    <el-row :gutter="20">
                      <el-col :xs="24" :sm="24">
                        <div class="kpis-page-col-box-row2-c kpcbrc4">
                          <h4>{{ $t('kpi.s13') }}</h4>
                          <h5 v-html="infringementseller.percentagehtml"></h5>
                          <MiniLineChart :chartdata="infringementseller.trend" minilineid="minilineid8" />
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="report-selector-row">
        <span>{{ $t('report.s5') }}</span>
      </div>

      <div class="report-charts-row">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="dashboard-container">
              <LineChart 
                :charttitle="$t('report.s10')" 
                :chartdata="linechartdata"
                :animation="true"
                chartid="line1"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dashboard-container">
              <LineChart 
                :charttitle="$t('report.s27')" 
                :chartdata="linechartdata1"
                :animation="true"
                chartid="line2"
              />
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="report-charts-row">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="dashboard-container">
              <BarChartStack
                :charttitle="$t('report.s11')"
                :chartdata="barchartstackdata"
                chartid="barchartstack1"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dashboard-container">
              <BarChartStack
                :charttitle="$t('report.s28')"
                :chartdata="barchartstackdata1"
                chartid="barchartstack2"
              />
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="report-charts-row">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="dashboard-container">
              <LineMultChart 
                :charttitle="$t('report.s56')" 
                :chartdata="linemultchartdata0"
                :animation="true"
                chartid="line3"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dashboard-container">
              <LineMultChart 
                :charttitle="$t('report.s57')" 
                :chartdata="linemultchartdata1"
                :animation="true"
                chartid="line4"
              />
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="report-selector-row mt15">
        <span>{{ $t('report.s14') }}</span>
      </div>
      
      <div class="report-table">
        <div class="report-table-tabs">
          <ul>
            <li :class="{ activetabsbtn: selectedTab === 1}">
              <button @click="onSelectTab(1)" type="button">{{ $t('kpi.s104') }}</button></li>
            <li :class="{ activetabsbtn: selectedTab === 2}">
              <button @click="onSelectTab(2)" type="button">{{ $t('kpi.s105') }}</button></li>
            <li :class="{ activetabsbtn: selectedTab === 3}">
              <button @click="onSelectTab(3)" type="button">{{ $t('kpi.s103') }}</button></li>
          </ul>
        </div>
        <div class="report-table-box">
          <div class="tablebox">
            <el-table v-if="showtab1" :data="top10data1" v-loading="tableloading" size="mini">
              <el-table-column type='index' label=" "></el-table-column>
              <el-table-column prop='ShopId' label="SHOPID"></el-table-column>
              <el-table-column :label="$t('report.s33')">
                <template slot-scope="scope">
                  <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                </template>              
              </el-table-column>
              <el-table-column prop='SellerName' :label="$t('report.s55')"></el-table-column>
              <el-table-column :label="$t('report.s34')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.Channel"></i>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  {{ $t('aistring.s11') }}
                  <el-tooltip class="item" effect="dark" :content="saletype != 2 ? $t('jgjk.s301') : $t('jgjk.s302')" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">{{ scope.row.SkuTotalTrade }}</template>              
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  {{ $t('jgjk.s244') }}
                  <el-tooltip class="item" effect="dark" :content="saletype != 2 ? $t('jgjk.s301') : $t('jgjk.s302')" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>  
              </el-table-column>
              <el-table-column prop='Discount' :label="$t('report.s60')"></el-table-column>
              <el-table-column prop='OFF' :label="$t('report.s61')"></el-table-column>
              <el-table-column width="1"></el-table-column>
            </el-table>

            <el-table v-if="showtab2" :data="top10data2" v-loading="tableloading" size="mini">
              <el-table-column type='index' label=" "></el-table-column>
              <el-table-column prop='ShopId' label="SHOPID"></el-table-column>
              <el-table-column :label="$t('report.s33')">
                <template slot-scope="scope">
                  <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                </template>              
              </el-table-column>
              <el-table-column prop='SellerName' :label="$t('report.s55')"></el-table-column>
              <el-table-column :label="$t('report.s34')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.Channel"></i>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  {{ $t('jgjk.s244') }}
                  <el-tooltip class="item" effect="dark" :content="saletype != 2 ? $t('jgjk.s301') : $t('jgjk.s302')" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>  
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  {{ $t('aistring.s11') }}
                  <el-tooltip class="item" effect="dark" :content="saletype != 2 ? $t('jgjk.s301') : $t('jgjk.s302')" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">{{ scope.row.SkuTotalTrade }}</template>              
              </el-table-column>
              <el-table-column prop='Discount' :label="$t('report.s60')"></el-table-column>
              <el-table-column prop='OFF' :label="$t('report.s61')"></el-table-column>
            </el-table>

            <el-table v-if="showtab3" :data="top10data3" v-loading="tableloading" size="mini">
              <el-table-column type='index' label=" "></el-table-column>
              <el-table-column prop='ShopId' label="SHOPID"></el-table-column>
              <el-table-column :label="$t('report.s33')">
                <template slot-scope="scope">
                  <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                </template>              
              </el-table-column>
              <el-table-column prop='SellerName' :label="$t('report.s55')"></el-table-column>
              <el-table-column :label="$t('report.s34')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.Channel"></i>
                </template>
              </el-table-column>
              <el-table-column prop='Discount' :label="$t('report.s60')"></el-table-column>
              <el-table-column prop='OFF' :label="$t('report.s61')"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniLineChart from '@/components/Charts/MiniLineChart.vue'
import LineChart from '@/components/Charts/LineChart.vue'
import LineMultChart from '@/components/Charts/LineMultChart.vue'
import BarChartStack from '@/components/Charts/BarChartStack.vue'
import DataPending from '@/components/Commons/DataPending.vue'
export default {
  components: {
    MiniLineChart,
    LineChart,
    LineMultChart,
    BarChartStack,
    DataPending
  },
  data(){
    return{
      top10data1: [],
      top10data2: [],
      top10data3: [],
      selectedTab: 1,
      showtab1: true,
      showtab2: false,
      showtab3: false,
      reportchk1: '',
      reportchk2: '',
      reporttype: 1,
      reporttime: '',
      brandid: this.$route.params.Id,
      latestupdatetime: '',
      totalsku: {},
      totalseller: {},
      lowpricesku: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      lowpriceseller: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      infringementsku: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      infringementseller: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      indicatorquery: {
        subid: this.$route.params.Id,
        page: 1,
        size: 25,
        order: 21
      },
      timeschartdata: [],
      successpercent: {},
      listdata: [],
      currentpage: 1,
      pagingtotal: 0,
      totalcount: {
        sku: 0,
        spu: 0,
        skusuccess: 0,
        spusuccess: 0
      },
      tstype: 0,
      shengyu: 0,
      yishiyong: 0,
      zongdian: 0,
      jindutiao: '100%',
      showlists: false,
      showinfringements: false,

      tableloading: false,
      projectid: '',
      latestmonth: '',
      last3months: [],
      linechartdata: {},
      piechartdata: {},
      barchartstackdata: {},
      barchartdataset: {},
      top10products: [],
      currenttopitem: '',
      barndname: '',
      linechartdata1: {},
      piechartdata1: {},
      barchartstackdata1: {},
      weeks: [],
      months: [],
      saletype: '',
      emptydate: false,
      mindate: {},
      mindex: 0,
      windex: 0,
      showmonths: true,
      show1: true,
      show2: true,
      linemultchartdata0: {
        xAxis_data: [],
        series_data: []
      },
      linemultchartdata1: {
        xAxis_data: [],
        series_data: []
      },
    }
  },

  mounted(){
    let that = this
    let pkglist = JSON.parse(localStorage.getItem("price")).val
    let currentpkg = pkglist.find(o => o.subid/1 === that.brandid/1)
    that.showinfringements = currentpkg.level/1 === 3 ? true : false
    that.saletype = currentpkg.saletype
    that.getMindate(function(){

      that.setWeekMonth()
      
      if(that.mindate.minweek == null){
        that.emptydate = true
        return
      }
      let nowday = new Date()
      let _m = that.$moment(nowday).diff(that.$moment(that.mindate.minmonth), 'months')
      that.mindex = _m > 3 ? 3 : _m > 0 && _m <= 3 ? _m : 0
      that.reporttype = 2
      that.reporttime = that.weeks[1].value + ',' + that.weeks[0].value

      if(that.weeks[0].value * 1 == that.mindate.minweek * 1){
        that.windex = 1
      }
      if(that.weeks[1].value * 1 == that.mindate.minweek * 1){
        that.windex = 2
      }
      if(that.weeks[2].value * 1 == that.mindate.minweek * 1){
        that.windex = 3
      }
      if(that.weeks[3].value * 1 >= that.mindate.minweek * 1){
        that.windex = 4
      }
      if(that.mindex == 0){
        that.showmonths = false
        that.reportchk1 = ''
        that.reporttype = 2
        that.reportchk2 = that.weeks[0].value
        that.reporttime = that.weeks[1].value + ',' + that.weeks[0].value
      }
      that.initPage()
    })
  },

  methods: {

    /**
     * 设置时间周期
     */
    setWeekMonth: function(){
      let that = this
      let now = JSON.parse(JSON.stringify(new Date()))

      let thisweek = that.$moment(now).subtract(1, 'weeks')
      let last1week = that.$moment(now).subtract(2, 'weeks')
      let last2week = that.$moment(now).subtract(3, 'weeks')
      let last3week = that.$moment(now).subtract(4, 'weeks')
      let last4week = that.$moment(now).subtract(5, 'weeks')

      let w1 = that.$moment(thisweek).isoWeeks().toString()
      let w2 = that.$moment(last1week).isoWeeks().toString()
      let w3 = that.$moment(last2week).isoWeeks().toString()
      let w4 = that.$moment(last3week).isoWeeks().toString()
      let w5 = that.$moment(last4week).isoWeeks().toString()

      let w1s = that.$moment(thisweek).startOf('week').add(1, 'd').format('MM.DD')
      let w2s = that.$moment(last1week).startOf('week').add(1, 'd').format('MM.DD')
      let w3s = that.$moment(last2week).startOf('week').add(1, 'd').format('MM.DD')
      let w4s = that.$moment(last3week).startOf('week').add(1, 'd').format('MM.DD')
      let w5s = that.$moment(last4week).startOf('week').add(1, 'd').format('MM.DD')

      let w1e = that.$moment(thisweek).endOf('week').add(1, 'd').format('MM.DD')
      let w2e = that.$moment(last1week).endOf('week').add(1, 'd').format('MM.DD')
      let w3e = that.$moment(last2week).endOf('week').add(1, 'd').format('MM.DD')
      let w4e = that.$moment(last3week).endOf('week').add(1, 'd').format('MM.DD')
      let w5e = that.$moment(last4week).endOf('week').add(1, 'd').format('MM.DD')

      let y1 = that.$moment(thisweek).format('YYYY').toString()
      let y2 = that.$moment(last1week).format('YYYY').toString()
      let y3 = that.$moment(last2week).format('YYYY').toString()
      let y4 = that.$moment(last3week).format('YYYY').toString()
      let y5 = that.$moment(last4week).format('YYYY').toString()
      
      let _w1 = w1 < 10 ? '0' + (w1) : w1
      let _w2 = w2 < 10 ? '0' + (w2) : w2
      let _w3 = w3 < 10 ? '0' + (w3) : w3
      let _w4 = w4 < 10 ? '0' + (w4) : w4
      let _w5 = w5 < 10 ? '0' + (w5) : w5

      let m1 = that.$moment(that.$moment(now).subtract(1, 'months')).format('YYYY-MM')
      let m2 = that.$moment(that.$moment(now).subtract(2, 'months')).format('YYYY-MM')
      let m3 = that.$moment(that.$moment(now).subtract(3, 'months')).format('YYYY-MM')
      let m4 = that.$moment(that.$moment(now).subtract(4, 'months')).format('YYYY-MM')
      
      let week1 = {
        value: y1 + '' + _w1,
        label: _w1 + that.$t('kpi.s112'),
        tips: w1s + '-' + w1e
      }
      let week2 = {
        value: y2 + '' + _w2,
        label: _w2 + that.$t('kpi.s112'),
        tips: w2s + '-' + w2e
      }
      let week3 = {
        value: y3 + '' + _w3,
        label: _w3 + that.$t('kpi.s112'),
        tips: w3s + '-' + w3e
      }
      let week4 = {
        value: y4 + '' + _w4,
        label: _w4 + that.$t('kpi.s112'),
        tips: w4s + '-' + w4e
      }
      let week5 = {
        value: y5 + '' + _w5,
        label: _w5 + that.$t('kpi.s112'),
        tips: w5s + '-' + w5e
      }

      let month1 = {
        value: m1,
        label: m1,
        tips: m1
      }
      let month2 = {
        value: m2,
        label: m2,
        tips: m2
      }
      let month3 = {
        value: m3,
        label: m3,
        tips: m3
      }
      let month4 = {
        value: m4,
        label: m4,
        tips: m4
      }
      
      that.weeks = [week1, week2, week3, week4, week5]
      that.months = [month1, month2, month3, month4]
      that.reportchk2 = week1.value
    },

    /**
     * 初始化页面
     */
    initPage: function(){
      let that = this
      that.getBrandname()
      that.getDashboard()
      that.getDashboardItem()
      that.getDashboardSale()
      that.getDashboardSeller()
      that.getTop10Tables(1)
    },

    /**
     * 获取最新报告时间
     */
    getMindate: function(callback){
      let that = this
      let url = that.API_URL + 
                '/v3/price/statistics/dateInfo?subid=' +
                that.$route.params.Id
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          that.mindate = data.results
          callback()
        },
        error: function(err){
          console.log(err)
        }
      })

    },

    /**
     * 选择时间
     */
    setQueryTimeM: function(val){
      let that = this
      let _i = that.getArrayIndex(that.months, val)
      that.reportchk2 = ''
      that.reporttype = 1
      let querytime = that.months[_i+1].value + ',' + val
      that.reporttime = querytime
      that.getDashboard()
      that.getDashboardItem()
      that.getDashboardSale()
      that.getDashboardSeller()
      that.getTop10Tables(1)
    },
    setQueryTimeW: function(val){
      let that = this
      let _i = that.getArrayIndex(that.weeks, val)
      that.reportchk1 = ''
      that.reporttype = 2
      let querytime = that.weeks[_i+1].value + ',' + val
      that.reporttime = querytime
      that.getDashboard()
      that.getDashboardItem()
      that.getDashboardSale()
      that.getDashboardSeller()
      that.getDashboardSale()
      that.getTop10Tables(1)
    },

    /**
     * Tabs切换
     */
    onSelectTab: function(tid){
      let that = this
      that.top10data1 = []
      that.top10data2 = []
      that.top10data3 = []

      if(tid == 1){
        that.selectedTab = 1
        that.showtab1 = true
        that.showtab2 = false
        that.showtab3 = false
        that.getTop10Tables(1)
      }
      if(tid == 2){
        that.selectedTab = 2
        that.showtab1 = false
        that.showtab2 = true
        that.showtab3 = false
        that.getTop10Tables(2)
      }
      if(tid == 3){
        that.selectedTab = 3
        that.showtab1 = false
        that.showtab2 = false
        that.showtab3 = true
        that.getTop10Tables(3)
      }
      
    },

    /**
     * 获取品牌名
     */
    getBrandname: function(){
      let brandinfo = JSON.parse(localStorage.getItem("price")).val
      let that = this
      let newArr = brandinfo.filter((item)=>{
        return item.subid/1 === that.brandid/1
      })
      let brand = newArr[0].name
      let barndname = brand.split('/')
      that.barndname = barndname[1] == undefined ? barndname[0] : barndname[1]
    },

    /**
     * showlists
     */
    listStatus: function(){
      let that = this
      let _objstorage = JSON.parse(localStorage.getItem("price")).val
      let mapobj = _objstorage.filter(item => {
        return item.subid/1 === that.brandid/1
      })
      that.showlists = mapobj[0].tscount == null ? false : true
    },

    /**
     * 周期对比
     */
    getDashboard: function(){
      let that = this
      let _t = JSON.parse(JSON.stringify(that.reporttime))
      let _ts = _t.split(',')
      let url = that.API_URL + 
                '/v3/commerce/indicator/dashboard?subid=' + 
                that.$route.params.Id + 
                '&type=' +
                that.reporttype +
                '&time=' +
                '\'' + _ts[0] + '\'' + ',' + '\'' + _ts[1] + '\''
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log('getDashboard', data)

          let infringementlist = data.results[6][0]
          let lowpricelist = data.results[7][0]

          // 本期侵权率
          let currentinfringementsku = infringementlist.length > 0 ? infringementlist[0].skurate : 0
          let currentinfringementsku_p = infringementlist.length > 1 ? currentinfringementsku - infringementlist[1].skurate : 0
          // 本期侵权卖家占比
          let currentinfringementseller = infringementlist.length > 0 ? infringementlist[0].shoprate : 0
          let currentinfringementseller_p = infringementlist.length > 1 ? currentinfringementseller - infringementlist[1].shoprate : 0
          // 本期低价率
          let currentlowpricesku = lowpricelist.length > 0 ? lowpricelist[0].skurate : 0
          let currentlowpricesku_p = lowpricelist.length > 1 ? currentlowpricesku - lowpricelist[1].skurate : 0
          // 本期低价卖家占比
          let currentlowpriceseller = lowpricelist.length > 0 ? lowpricelist[0].shoprate : 0
          let currentlowpriceseller_p = lowpricelist.length > 1 ? currentlowpriceseller - lowpricelist[1].shoprate : 0

          // 最近更新时间
          that.latestupdatetime = that.$moment(data.results[8][0].scoreTime).utc().format('YYYY-MM-DD')

          // 累计SKU
          that.totalsku = {
            last: that.millonFormat(data.results[0][0].lastskuweekCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[0][0].skuweekCount), data.results[0][0].skuweekRate)
          }
          // 累计卖家
          that.totalseller = {
            last: that.millonFormat(data.results[1][0].lastshopweekCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[1][0].shopweekCount), data.results[1][0].shopweekRate)
          }
          // 低价SKU
          that.lowpricesku = {
            last: that.millonFormat(data.results[2][0].lastskuweeklowCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[2][0].skuweeklowCount), data.results[2][0].skuweeklowRate),
            percentagehtml: that.setPercentage(currentlowpricesku, currentlowpricesku_p),
            trend: {
              xdata: lowpricelist.reverse().map(item => {
                return item.weeks
              }),
              ydata: lowpricelist.reverse().map(item => {
                return item.skurate * 100
              })
            }
          }
          // 低价卖家
          that.lowpriceseller = {
            last: that.millonFormat(data.results[3][0].lastshopweeklowCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[3][0].shopweeklowCount), data.results[3][0].shopweeklowRate),
            percentagehtml: that.setPercentage(currentlowpriceseller, currentlowpriceseller_p),
            trend: {
              xdata: infringementlist.reverse().map(item => {
                return item.weeks
              }),
              ydata: infringementlist.reverse().map(item => {
                return item.shoprate * 100
              })
            }
          }
          // 侵权SKU
          that.infringementsku = {
            last: that.millonFormat(data.results[4][0].lastskuweekqinCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[4][0].skuweekqinCount), data.results[4][0].skuweekqinRate),
            percentagehtml: that.setPercentage(currentinfringementsku, currentinfringementsku_p),
            trend: {
              xdata: infringementlist.reverse().map(item => {
                return item.weeks
              }),
              ydata: infringementlist.reverse().map(item => {
                return item.skurate * 100
              })
            }
          }
          // 侵权卖家
          that.infringementseller = {
            last: that.millonFormat(data.results[5][0].lastshopweekqinCount),
            currenthtml: that.setCompare(that.millonFormat(data.results[5][0].shopweekqinCount), data.results[5][0].shopweekqinRate),
            percentagehtml: that.setPercentage(currentinfringementseller, currentinfringementseller_p),
            trend: {
              xdata: lowpricelist.reverse().map(item => {
                return item.weeks
              }),
              ydata: lowpricelist.reverse().map(item => {
                return item.shoprate * 100
              })
            }
          }

        },
        error: function(err){
          console.log(err)
        }
      })      
    },

    /**
     * 数据看板 - 商品
     */
    getDashboardItem: function(){
      let that = this
      let _time = that.reporttime.split(',')[1]
      let url = that.API_URL + 
                '/v3/price/statistics/iteminfo?subid=' +
                that.$route.params.Id + 
                '&type=' +
                that.reporttype +
                '&time=' +
                _time
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          let boarddata = data.results.board

          // LineChart
          let lineChartDataObj = data.results.chart[0]
          let x = [];
          let y = [];
          for (var i = 0; i < lineChartDataObj.length; i++) {
              x[i] = that.$moment(lineChartDataObj[i].CurrentDate).format('YYYY-MM-DD')
              y[i] = lineChartDataObj[i].ItemCount
          }
          that.linechartdata = {
            xAxis: x,
            yAxis: [{
              type: 'line',
              smooth: true,
              data: y
            }]
          }

          /**
           * BarChart
           */
          let barresults = data.results.chart[1]
          barresults.forEach(item => {
            item.ChannelStr = that.setChannel(item.Channel).loc
          })
          that.barchartstackdata = {
            legenddata0: barresults.length > 0 ? that.$t("Infringements.t15") : '',
            legenddata1: barresults.length > 0 ? that.$t("Infringements.t11") : '',
            channelname: barresults.map(item => {return item.ChannelStr}),
            data0: barresults.map(item => {return item.OtherItem}),
            data1: barresults.map(item => {return item.FakeItem}),
          }

          /**
           * 判断店铺是否有淘宝、天猫或其他
           */
          // let _show1=0
          // let _show2=0
          // for(let m=0; m<barresults.length; m++){
          //   if(barresults[m].Channel == '淘宝' || barresults[m].Channel == '天猫'){
          //     _show1 = _show1 + 1
          //   }else{
          //     _show2 = _show2 + 1
          //   }
          // }
          // if(_show1 > 0){
          //   that.show1 = true
          //   if(_show2 == 0){
          //     that.show2 = false
          //   }
          // }else{
          //   that.show1 = false
          //   that.selectedTab = 2
          //   that.getTop10Tables(2)
          // }

        },
        error: function(err){
          console.log(err)
        }
      })      
    },    
    
    /**
     * 数据看板 - 卖家
     */
    getDashboardSeller: function(){
      let that = this
      let _time = that.reporttime.split(',')[1]
      let url = that.API_URL +
                '/v3/price/statistics/shopinfo?subid=' +
                that.$route.params.Id + 
                '&type=' +
                that.reporttype +
                '&time=' +
                _time
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          // LineChart
          let lineChartDataObj = data.results.chart[0]
          let x = [];
          let y = [];
          for (var i = 0; i < lineChartDataObj.length; i++) {
              x[i] = that.$moment(lineChartDataObj[i].CurrentDate).format('YYYY-MM-DD')
              y[i] = lineChartDataObj[i].ShopCount
          }
          that.linechartdata1 = {
            xAxis: x,
            yAxis: [{
              type: 'line',
              smooth: true,
              data: y
            }]
          }

          /**
           * BarChart
           */
          let barresults = data.results.chart[1]
          barresults.forEach(item => {
            item.ChannelStr = that.setChannel(item.Channel).loc
          })
          that.barchartstackdata1 = {
            legenddata0: barresults.length > 0 ? that.$t("Seller.t6") : '',
            legenddata1: barresults.length > 0 ? that.$t("Seller.t5") : '',
            channelname: barresults.map(item => {return item.ChannelStr}),
            data0: barresults.map(item => {return item.OtherShop}),
            data1: barresults.map(item => {return item.FakeShop}),
          }

        },
        error: function(err){
          console.log(err)
        }
      })      
    },
    
    /**
     * 数据看板 - 销售额
     */
    getDashboardSale: function(){
      let that = this
      let _time = that.reporttime.split(',')[1]
      let url = that.API_URL +
                '/v3/price/statistics/salesinfo?subid=' +
                that.$route.params.Id + 
                '&type=' +
                that.reporttype +
                '&time=' +
                _time
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          let _s0 = data.results.sales
          let _s1 = data.results.salesvolume
          let _sd0 = []
          let _sd1 = []
          for(let i=0; i<_s0.length; i++){
            let _a = {
              color: that.setChannel(_s0[i].name).color,
              name: that.setChannel(_s0[i].name).loc,
              data: _s0[i].data.map(item => {
                return item <= 0 ? 0.00 : item
              }),
              type: 'line'
            }
            _sd0.push(_a)
          }
          for(let j=0; j<_s1.length; j++){
            let _b = {
              color: that.setChannel(_s1[j].name).color,
              name: that.setChannel(_s1[j].name).loc,
              data: _s1[j].data.map(item => {
                return item <= 0 ? 0.00 : item
              }),
              type: 'line'
            }
            _sd1.push(_b)
          }
          that.linemultchartdata0 = {
            xAxis_data: data.results.xdatetime,
            series_data: _sd0
          }
          that.linemultchartdata1 = {
            xAxis_data: data.results.xdatetime,
            series_data: _sd1
          }
        },
        error: function(err){
          console.log(err)
        }
      })      
    },

    /**
     * 低价链接数产品排名Top10
     */
    getTop10Tables: function(tid){
      let that = this
      let _time = that.reporttime.split(',')[1]
      that.tableloading = true
      let url = that.API_URL + 
                '/v3/price/statistics/shoplist?subid=' +
                that.$route.params.Id + 
                '&type=' +
                that.reporttype +
                '&time=' +
                _time +
                '&order=' +
                tid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          let res = data.results
          if(tid == 1){
            that.top10data1 = that.setReportTable(res)
          }
          if(tid == 2){
            that.top10data2 = that.setReportTable(res)
          }
          if(tid == 3){
            that.top10data3 = that.setReportTable(res)
          }
          that.tableloading = false
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 查找下标
     */
    getArrayIndex: function(arr, s){
      let i = ''
      for(let j=0; j<arr.length; j++){
        if(arr[j].value == s){
          i = j
        }
      }
      return i
    },
    
    /**
     * 获取月份列表
     */
    getMonthLists: function(rds, callback){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/detail'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
				data: {subid: rds},
        success: function(data){
          console.log('getMonthLists', data)
          that.latestmonth = data.results[0].CurrentMonth
          let _last3months = []
          for(let i=0 ;i<data.results.length; i++){
            let _obj = {
              label: '',
              value: data.results[i].CurrentMonth
            }
            _last3months.push(_obj)
          }
          that.last3months = _last3months
          callback(data.results[0].CurrentMonth)
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 下载PDF
     */
    downloaddata: function(){
      let that = this
      let _type = that.reporttype == 1 ? '月报' : '周报'
      let url = that.API_URL + '/v3/price/statistics/downloadPdf?project='
                +that.brandid
                +'&month='
                +that.reporttime.split(',')[1]
                +'&type='
                +_type
                +'&language='
                +that.$i18n.locale
                +'&name='
                +that.barndname
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log('downloaddata', data)
          that.downFile(data.results.url)
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 下载
     */
    downFile (url) {
      const link = document.createElement('a')
      console.log(link)
      link.href = url
      link.target = '_blank'
      link.click()
    },

  }

}
</script>
